import { NavLink} from 'react-router-dom'
import { CartIcon, HomeIcon, ListIcon, OrderIcon, path, ProductIcon, SearchIcon, ShopIcon } from '../../base'
import { useSelector } from 'react-redux'

function BootomTab() {

  const cart_total_item = useSelector((state)=>state.appSlice.cart_total_item)

  return (
    <div className='bottomTab d-flex d-md-none'>
      <NavLink to={path.home} className='link smallText pcolor'><HomeIcon /><span>Home</span></NavLink>
      <NavLink to={'/p/shop/all/category/all/products/'} className='link smallText pcolor'><ProductIcon /><span>Products</span></NavLink>
      <NavLink to={path.demo_category} className='link smallText pcolor'><ListIcon /><span>Category</span></NavLink>
      <NavLink to={path.product_search} className='link smallText pcolor'><SearchIcon style={{ width: '23px' }} /><span>Search</span></NavLink>
      <NavLink to={path.cart} className='link smallText pcolor position-relative'><CartIcon /><span>Cart</span><span className='cartTotalItem'>{cart_total_item}</span></NavLink>
      <NavLink to={path.all_order} className='link smallText pcolor'><OrderIcon style={{ width: '18px' }} /><span>Orders</span></NavLink>
    </div>
  )
}

export default BootomTab